window.Vue = require('vue');
import VueSignature from "vue-signature-pad";
Vue.use(VueSignature);
var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo)

// You can also pass in the default options
Vue.use(VueScrollTo, {
    container: "#scroll-to-top-section",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

Vue.component('job-frontend-header-component', require('./layouts/header').default);
Vue.component('job-frontend-footer-component', require('./layouts/footer').default);
Vue.component('job-frontend-job-board-component', require('./pages/landing/index').default);

Vue.component('job-frontend-job-details-buttons-component', require('./pages/job-details/buttons').default);

Vue.component('job-frontend-job-application-component', require('./pages/application/index').default);
Vue.component('job-frontend-job-application-thanks-component', require('./pages/application/ThankYou').default);
